export const searchParticipantsQuery = `
query SearchParticipants(
  $keyword: String!
  $nextToken: String
) {
  searchParticipants(
    keyword: $keyword
    nextToken: $nextToken
  ) {
    items {
      participantId
      participantRef
      participantStatus
      email
      firstName
      surname
      sexAtBirth
      dob
      nhsNumber
    }
    nextToken
  }
}`;

export const getParticipantQuery = `
query GetParticipant($participantId: String!) {
  getParticipant(participantId: $participantId) {
    participantId
    participantRef
    participantStatus
    firstName
    surname
    address1
    address2
    town
    postcode
    genderIdentity
    sexAtBirth
    dob
    nhsNumber
    landline
    mobile
    email
    communicationOptIn
    ancestryOptIn
    ehrOptIn
    enrolmentTs
    withdrawalLevel
    withdrawalReason
    withdrawalTs
    consent1
    consent2
    consent3
    consent4
    consent5
    consent6
    consent7
    consent8
    consent9
    consentFormDate
    consentFormVersion
    pisDate
    pisVersion
    pisConfirm
    videoConfirm
    privacyAccepted
    termsAccepted
    termsVersion
    site {
      odsCode
      siteName
      siteSystem
      siteAddress1
      siteAddress2
      siteTown
      sitePostcode
      isInitiated
    }
    ehr {
      dataHasArrivedTs
      ehrIsLoc
      ehrStatus
      ehrUpdatedTs
      ehrIsDeceased
      ehrUpdates {
        ehrIsLoc
        ehrStatus
        ehrUpdatedTs
        ehrIsDeceased
      }
    }
    sample {
      sampleLinkTs
      sampleBarcode
      sampleReceivedTs
      sampleReminderSent
      sampleViable
      orderStatus
      orderNum
      orderSequencer
      orderUpdatedTs
      sampleUpdates {
        orderStatus
        orderNum
        orderRef
        orderSequencer
        orderUpdatedTs
      }
    }
    lab {
      sampleBarcode
      boxBarcode
      samplePosition
      shipped
      shippedDate
    }
  }
}`;

export const searchSitesQuery = `
query SearchSites(
  $keyword: String!
  $nextToken: String
) {
  searchSitesQuery(
    keyword: $keyword
    nextToken: $nextToken
  ) {
    items {
      name
      code
      address1
      address2
      postcode
      initiated
      provider
    }
    nextToken
  }
}`;

export const getSiteQuery = `
query GetSite($code: String!) {
  getSiteQuery(code: $code) {
    name
    code
    address1
    address2
    postcode
    initiated
    provider
  }
}`;
